<div class="mx-auto mb-5 max-w-5xl">
	<div class="ay-page-title">
		<ng-content select="uikit-page-title, ay-page-title"></ng-content>
	</div>
	<ng-content select="ay-page-main"></ng-content>
</div>
